import gsap from 'gsap';
import classToggle from '../helpers/class-toggle';
import productCard from './product-card';
import quickbuy from './quickbuy';

export default () => {
	const items = document.querySelectorAll('.js-filter-item');
	items.forEach(function(item) {
		item.addEventListener('click', (e) => {
			e.preventDefault();
		
			let isActive = item.classList.toggle('filter-popup__item--active');

			const buttonApply = document.querySelector('.filter-popup__btn');
			if (buttonApply) {
				buttonApply.classList.add('js-apply-filter');
			}

			if (isActive) {
				addFacet(item)
			} else {
				const id = item.dataset.id;
				const facet = document.querySelector(`[data-id="${id}"]`);
				removeFacet(facet)
			}
		});
	});

	function addFacet(item) {
		let wrapper  = document.querySelector('.filter-popup__facets');

		const name = item.innerText;
		const param = item.dataset.param;
		const id = item.dataset.id;
		let circle = '';

		if (param == 'filter.p.m.custom.color_swatch_title') {
			const image = item.querySelector('img');
			circle = `<span class="filter-popup__facet-circle">
				${image.outerHTML}
			</span>`
		}

		let facet = `<div class="filter-popup__facet" data-param="${param}" data-id="${id}"><span class="filter-popup__facet-remove"></span>${circle}${name}</div>`;

		wrapper.innerHTML += facet;
	}

	function removeFacet(item) {
		let wrapper  = document.querySelector('.filter-popup__facets');
		let name = item.innerText;
		let param = item.dataset.param;
		item.remove();

		let swatches = document.querySelectorAll('.js-filter-item');
		swatches.forEach(function(swatch) {
			let swatchName = swatch.innerText;
			let swatchParam = swatch.dataset.param;

			if (name == swatchName && param == swatchParam) {
				swatch.classList.remove('filter-popup__item--active');
			}
		});

		const buttonApply = document.querySelector('.filter-popup__btn');
		if (buttonApply) {
			buttonApply.classList.add('js-apply-filter');
		}
	}

	document.addEventListener('click', (e) => {
		if (e.target.closest('.filter-popup__facet')) {
			const facet = e.target.closest('.filter-popup__facet');
			removeFacet(facet);
		}
	});

	const sortOptions = document.querySelectorAll('.js-sort-option');
	sortOptions.forEach(function(option) {
		option.addEventListener('click', (e) => {
			e.preventDefault();
			classToggle(sortOptions, option, 'filter-popup__item--active');
			const buttonApply = document.querySelector('.filter-popup__btn');
			if (buttonApply) {
				buttonApply.classList.add('js-apply-filter');
			}
		});
	});


	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-apply-filter')) {
			applyFilter();
		}
		if (e.target.closest('.js-close-filter')) {
			const popup = document.querySelector('.filter-popup');
			popup.classList.remove('filter-popup--visible');

			setTimeout(function(){
				const buttonApply = document.querySelector('.filter-popup__btn');
				if (buttonApply) {
					buttonApply.classList.remove('js-apply-filter');
				}
			}, 500);
		}
	});

	const closeButtons = document.querySelectorAll('.js-open-filter');
	closeButtons.forEach(function(button) {
		button.addEventListener('click', (e) => {
			const popup = document.querySelector('.filter-popup');
			popup.classList.add('filter-popup--visible');
		});
	});

	function applyFilter() {
		const filter = document.querySelector('.js-filter-popup');
		let checkboxes = document.querySelectorAll('.js-filter-item');
		let filtersString = '';
		let grid = document.querySelector('.js-product-grid');


		const popup = document.querySelector('.filter-popup');
		popup.classList.remove('filter-popup--visible');


		let cards = grid.querySelectorAll('.js-card');
		gsap.to(cards, {
			opacity: 0,
			duration: 0.2
		})

		let sectionId;
		const section = filter.closest('.shopify-section');

		if (section) {
			sectionId = ''+section.id.replace('shopify-section-', '');
		}

		checkboxes.forEach(function(checkbox) {
			if (checkbox.classList.contains('filter-popup__item--active')) {
				let name = checkbox.dataset.param;
				let value = checkbox.innerText;

				if (name && value) {
					filtersString += `&${name}=${value}`;
				}
			}
		});

		const activeSort = document.querySelector('.filter-popup__item--active.js-sort-option');
		if (activeSort) {
			filtersString += `&sort_by=${activeSort.dataset.id}`;
		}
		

		const base = window.location.href.split('?')[0];
		let url = `${base}?section_id=${sectionId}${filtersString}`;

		// let urlHistory = `${base}?${filtersString.substring(1)}`;
		// history.pushState('', '', urlHistory);


		fetch(url).then(function (response) {
			return response.text();
		}).then(function (html) {
			let element = document.createElement('div');
			element.innerHTML = html
			let newGrid = element.querySelector('.js-product-grid');
			grid.innerHTML = newGrid.innerHTML;

			let cards = grid.querySelectorAll('.js-card');
			gsap.set(cards, {
				opacity: 0
			})
			gsap.to(cards, {
				opacity: 1,
				duration: 0.3,
				stagger: 0.1
			});

			// apply events to new elements
			productCard();
			quickbuy();

			// if (counter) {
			// 	counter.innerText = cards.length;
			// }

		}).catch(function (err) {
			console.warn('Something went wrong.', err);
		});

		setTimeout(function(){
			const buttonApply = document.querySelector('.filter-popup__btn');
			if (buttonApply) {
				buttonApply.classList.remove('js-apply-filter');
			}
		}, 500);
	}


	// filter sort dropdown
	const sortDropdown = document.querySelector('.filter__sort');
	const sortExpandBtn = document.querySelector('.filter__sort .filter__btn');
	const sort = document.querySelector('.filter__sort');
	const popupOptions = document.querySelectorAll('.js-sort-option');

	if (sortDropdown) {
		const options = document.querySelectorAll('.filter__sort-item');
		options.forEach(function(option) {
			option.addEventListener('click', (e) => {
				if (!option.classList.contains('filter__sort-item--active')) {
					classToggle(options, option, 'filter__sort-item--active');
					let index = option.dataset.index;
					popupOptions[index].click();
					sort.classList.remove('filter__sort--expanded');
					applyFilter();
				}
			});
		});
	}

	if (sortExpandBtn && sort) {
		sortExpandBtn.addEventListener('click', (e) => {
			sort.classList.toggle('filter__sort--expanded');
		});
	}

	// mobile clear col
	let clearBtns = document.querySelectorAll('.js-clear-col');
	clearBtns.forEach(function(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			
			const col = btn.closest('.filter-popup__col')
			if (col) {
				const items = col.querySelectorAll('.js-filter-item');
				items.forEach(function(item) {
					if (item.classList.contains('filter-popup__item--active')) {
						item.click();
					}
				});
			}
		});
	});
}